import axios from 'axios'


const headers = {
    Accept: 'application/json',
    Source: 'ajax' // we set 'ajax' as source to obtain proper status codes instead of redirects from backend
}

const request = (method, url, data) => {

    return axios({
        headers,
        method,
        url,
        data
    })
}

export function get(route) {
    return request('GET', route);
}

export function post(route, data) {
    return request('POST', route, data);
}